import { FC } from 'react'
import useTranslation from 'next-translate/useTranslation'

import { formatPriceNumber } from '../../utils/math'
import { getPricePerPieceUnit } from '../../lib/salesUnit'
import { Product } from '../../utils/types/Product'

import styles from '../../styles/PriceDisplay.module.less'

interface PriceDisplayProps {
  price: number
  currency: string
  product: Product
  className?: string
}

const PriceDisplay: FC<PriceDisplayProps> = ({
  price,
  currency,
  product,
  className = '',
}) => {
  const { t } = useTranslation('products')

  const [wholePricePart, fractionalPricePart] = formatPriceNumber(price).split(',')

  return (
    <div
      className={`${styles['price-container']} ${className}`}
      data-testid="product-price"
    >
      <b className={styles['whole-price']}>
        {wholePricePart}
      </b>
      <div className={styles['right-side-container']}>
        <b className={styles['fractional-price']}>{`${fractionalPricePart} ${currency}`}</b>
        <p className={styles['per-piece']}>
          /
          {t(getPricePerPieceUnit(product), { count: 1 })}
        </p>
      </div>
    </div>
  )
}

export default PriceDisplay
